export const VIETNAM_PHONE =
  /^\+?(840|84|0)(8[1-9]|9[6-9]|9[0-4]|3[2-9]|70|7[6-9]|5[5-6]|5[8-9])\d{7}$/;

export const VIETNAM_PHONE_PREFIX = /^\+?(840|84|0)/;
